import templateUrl from './home-about-us.html';
import head from 'lodash/head';

export const homeAboutUsComponent = {
	templateUrl,

	bindings: {
		details: '<',
		slugUrl: '@'
	},

	controller: class HomeAboutUsComponent {
		$onInit() {
			this.details = angular.copy(head(this.details));
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/components/home-about-us/home-about-us.component.js